
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactToPrint from 'react-to-print';
import HeaderInvoice from '../bookings/invoice/HeaderInvoice';
import { View_control_expired, View_control_points, View_country_code_phone, View_date_create, View_date_created, View_user_approve, View_whatsapp_number } from '../constants/dataView';
import { View_check, View_state } from '../functions/data_view';
import UserDetailsView from './UserDetailsView';
import { _endPoints, deletecustomer } from '../Helper/links';
import pattern from "../Helper/pattern";
import API from "../Helper/server/API";
import logo from '../public/images/logo.png';
import imgCustomer from "../public/images/user.avif";
import UserAppEdit from "./UserAppEdit";

function UsersApp() {
    const Navigate = useNavigate();
    const toast = useRef(null);
    const componentRef = useRef();
    const buttonRef = useRef();
    const items = Array.from({ length: 19 }, (v, i) => i);
    const [isShown, setIsShown] = useState(false);
    const [show_user, set_show_user] = useState(false);
    const [show_edit, set_show_edit] = useState(false);
    const [show_delete, set_show_delete] = useState(false);
    const [name_phone, setname_phone] = useState("");
    const [loading_customers, set_loading_customers] = useState(false);
    const [customers, set_customers] = useState([]);
    const [customer_show, set_customer_show] = useState({});

    const [customers_view, set_customers_view] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: 1,
        search: ""
    });

    const clearFilter = () => {
        setname_phone("");
        setLazyParams(prev => ({ ...prev, first: 0, page: 1, search: "" }));
    };
    const handel_name_phone = (e) => {
        setname_phone(e.target.value)
    }
    const renderHeader = () => {
        return (
            <div className="col-md-12">
                <div className="row">
                    <div className="col-md-11">
                        <div className="flex justify-content-between" style={{ fontFamily: "Cairo", fontSize: "15px" }} dir="rtl">
                            <InputText
                                value={name_phone}
                                onChange={(e) => handel_name_phone(e)}
                                placeholder="الأسم أو رقم الهاتف"
                                className="col-md-4"
                                style={{ fontFamily: "Cairo", fontSize: "15px", width: "100%" }}
                            />
                            <Button
                                dir="ltr"
                                type="button"
                                icon="fa fa-remove"
                                outlined
                                severity="danger"
                                onClick={clearFilter}
                                style={{ marginRight: "0px" }}
                            />
                            <Button
                                dir="ltr"
                                type="button"
                                icon="fa fa-search"
                                outlined
                                onClick={() => setLazyParams(prev => ({ ...prev, first: 0, page: 1, search: name_phone }))}
                                style={{ marginRight: "5px" }}
                            />
                            <p style={{ fontSize: "18px" }} className="mt-2"> {totalRecords >= 0 ? totalRecords + " مستخدم" : null}</p>
                        </div>
                    </div>
                    <div className="col-md-1" style={{ textAlign: "left", fontFamily: "Cairo" }}>
                        <Button icon="fa fa-refresh" rounded outlined onClick={() => GetUsersApp(lazyParams.page, lazyParams.rows, lazyParams.search)} />
                    </div>
                </div>
            </div>
        );
    };
    const search = (e) => {
        e.preventDefault();
        setLazyParams(prev => ({ ...prev, first: 0, page: 1, search: name_phone }));
    };
    //                      Get Customers
    const GetUsersApp = async (page = 1, rows = 10, search = "") => {
        set_loading_customers(true);
        const response = await API.get(`${_endPoints.users_app.get_all}?page=${page}&pageSize=${rows}&search=${search}`);
        if (response?.success) {
            set_customers(response.data);
            set_customers_view(response.data);
            setTotalRecords(response.totalRecords);
        }
        set_loading_customers(false);
    }

    const View_note = (item) => {
        return (
            <p style={{ fontSize: "13px" }}>
                {item.note}
            </p>
        )
    }

    const View_Button = (item) => {
        return (
            <>
                <Button
                    type="button"
                    icon="pi pi-external-link"
                    severity="secondary"
                    text
                    onClick={(e) => {
                        set_customer_show(item)
                        set_show_user(true)
                    }}
                />
                <Button
                    type="button"
                    icon="fa fa-edit"
                    text
                    onClick={(e) => {
                        set_customer_show(item)
                        set_show_edit(true)
                    }}
                />

            </>
        )
    }



    useEffect(() => {
        GetUsersApp(lazyParams.page, lazyParams.rows, lazyParams.search);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lazyParams]);

    const onPage = (event) => {
        setLazyParams({
            ...lazyParams,
            first: event.first,
            rows: event.rows,
            page: event.page + 1
        });
    };
    const scrollStyle = {
        overflowY: "auto",
        scrollbarWidth: "thin", // للمتصفحات غير Chrome
    };
    const scrollBarCSS = `
    ::-webkit-scrollbar {
            display: block !important;
            width: 5px;
            height: 8px;
    }
    `;
    return (
        <div className="page-wrapper" dir="rtl" >
            <div className="content-wrapper">
                <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important", fontFamily: "Cairo" }} remove />
                <div className="page-heading">
                    <h1 className="page-title">المستخدمين التطبيق</h1>
                </div>
                <div className="card p-2">
                    <style>{scrollBarCSS}</style>
                    {
                        loading_customers ?
                            <DataTable value={items}
                                header={renderHeader}
                                className="p-datatable-striped"
                                tableStyle={{ minWidth: '50rem' }} style={{ fontFamily: "Cairo", direction: "rtl" }}>
                                <Column field="ID_user" header="المستخدم" sortable style={{ textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="name" header="الاسم" sortable style={{ textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="phone" header="رقم الهاتف" style={{ textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="whatsapp_number" header="رقم الواتساب" style={{ textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="email" header="البريد الإلكتروني" style={{ textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="state" header="حالتة" sortable style={{ textAlign: "right" }} body={<Skeleton />}></Column>
                                <Column field="ID_customer" header="أجراء" style={{ textAlign: "right", width: "10%" }} body={<Skeleton />}></Column>
                            </DataTable>
                            :
                            <DataTable value={customers_view} stripedRows
                                header={renderHeader} selectionMode="multiple"
                                lazy paginator first={lazyParams.first} rows={lazyParams.rows} totalRecords={totalRecords} onPage={onPage}
                                rowsPerPageOptions={[10, 20, 30, 50, 100]}
                                paginatorClassName={<i className="pi pi-angle-right"  ></i>}
                                emptyMessage={<center><h4>لا يوجد عملاء</h4></center>}
                                scrollable scrollHeight="850px"
                                tableStyle={scrollStyle}
                                style={{ fontFamily: "Cairo", direction: "rtl", fontSize: "15px", border: "10px" }}
                            >
                                <Column field="ID_user" header=" المستخدم" sortable style={{ textAlign: "right", width: "5%" }}></Column>
                                <Column field="name" header="الاسم" sortable style={{ textAlign: "right", width: "15%" }}></Column>
                                <Column field="phone" header="رقم الهاتف" style={{ textAlign: "right", width: "15%" }} body={View_country_code_phone}></Column>
                                <Column field="whatsapp_number" header="رقم الواتساب" style={{ textAlign: "right", width: "15%" }} body={View_whatsapp_number}></Column>
                                {/* <Column field="date_create" body={View_date_create}  header="تـاريخ الإضـافة"  style={{ textAlign:"right",width:"10%" }} ></Column> */}
                                <Column field="control_points" body={View_control_points} header="نقاط الحجز" sortable style={{ textAlign: "right" }}></Column>
                                <Column field="control_points" body={View_control_expired} header="حظر من الحجز" sortable style={{ textAlign: "right", width: "10%" }}></Column>


                                <Column field="state" body={View_state} header="حالتة" sortable style={{ textAlign: "right" }}></Column>


                                <Column field="ID_customer" body={View_Button} header="أجراء" style={{ textAlign: "right", width: "10%" }} ></Column>
                            </DataTable>
                    }
                </div>

                <Dialog dir="rtl" header="عــرض المتسخدم" visible={show_user} maximizable style={{ width: '70vw', fontFamily: "Cairo" }} onHide={() => set_show_user(false)} maximized={window.innerWidth <= 1230 ? true : false}
                    footer={
                        <center>
                            <Button label="إغـــلاق" severity="danger" outlined icon="pi pi-times ml-2" onClick={(e) => set_show_user(false)} />
                        </center>
                    }
                >
                    <UserDetailsView id_user={customer_show?.ID_user} />
                </Dialog>

                <Dialog dir="rtl" header="تعــديل المتسخدم" visible={show_edit} maximizable style={{ width: '80vw', fontFamily: "Cairo" }} onHide={() => set_show_edit(false)} maximized={window.innerWidth <= 1230 ? true : false}>
                    <UserAppEdit user={customer_show} toast={toast} set_show_edit={set_show_edit} GetUsersApp={() => GetUsersApp(lazyParams.page, lazyParams.rows, lazyParams.search)} />
                </Dialog>


            </div>
        </div>
    )
}

export default UsersApp


